import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { PageBackground } from "../../components/PageBackground";
import { ExportTemplatesAdmin } from "./ExportTemplatesAdmin";

// Full-page shell for the support-only /support/export-templates route.
// ExportTemplatesAdmin itself is a bare content component (designed to be
// embeddable); this wrapper gives it the same header/back-link/PageBackground
// treatment as SupportAdvertiserList so it's reachable as its own route.
export function ExportTemplatesPage() {
  const { user, signOut } = useAuth();

  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF", fontFamily: "'DM Sans','Helvetica Neue',sans-serif", color: "#151515", display: "flex", flexDirection: "column", position: "relative", overflow: "hidden" }}>
      <PageBackground />
      <div style={{ background: "rgba(255,255,255,0.85)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)", borderBottom: "1px solid #dad8d9", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12, position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <span style={{ fontSize: 10, color: "#F90091", letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600 }}>Internal support</span>
          <span style={{ color: "#626262", fontSize: 13 }}>{user?.email}</span>
        </div>
        <Link to="/support" style={{ fontSize: 13, color: "#626262", textDecoration: "none" }}>← Advertisers</Link>
        <button onClick={() => signOut()} style={{ padding: "8px 14px", background: "transparent", color: "#626262", border: "1px solid #E2E2E2", borderRadius: 8, fontSize: 12, cursor: "pointer" }}>Sign out</button>
      </div>
      <div style={{ flex: 1, padding: 28, maxWidth: 900, margin: "0 auto", width: "100%", position: "relative", zIndex: 1 }}>
        <ExportTemplatesAdmin />
      </div>
    </div>
  );
}
